module.exports = __webpack_public_path__ + "img/avant1.534a6acc.png";